
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import NavLink from './NavLink';
import { useIsMobile } from '@/hooks/use-mobile';

const NavbarLinks = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  
  // Don't show any navigation links
  return null;
};

export default NavbarLinks;
